import React from 'react';
import styled, { css } from 'styled-components';
import { ELabelPos } from '../types';

export const Label = styled<React.FC<{ className?: string }>>(
    ({ className, children }) => (
        <span className={className} data-id={'label'}>
            {children}
        </span>
    ),
)`
    grid-area: label;
    font-size: 13px;
`;

const defGridStyles = css`
    display: grid;
    gap: 0.75rem;
`;

export const Root = styled.div<{ labelPos?: ELabelPos }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    ${({ labelPos }) => {
        switch (labelPos) {
            case ELabelPos.left:
                return css`
                    ${defGridStyles};
                    grid-template-areas: 'label input';
                `;
            case ELabelPos.top:
                return css`
                    ${defGridStyles};
                    grid-template-areas: 'label' 'input';
                    grid-auto-flow: column;
                    grid-auto-columns: 100%;
                `;
            default:
                return css``;
        }
    }}
`;
